import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Countries from './components/Countries';
import Contact from './components/Contact';
import Footer from '@/components/feature/Footer';
import Seo from '@/seo/Seo';

export default function HomePage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Seo
        title="Global79 Lojistik | Kilis Merkezli Uluslararası Taşımacılık"
        description="Global79 Lojistik olarak Kilis merkezli yurtiçi, yurtdışı ve uluslararası taşımacılık hizmetleri sunuyoruz. Türkiye, Suriye, Azerbaycan, Irak, İran, Gürcistan, Ermenistan ve Rusya güzergahlarında güvenli teslimat."
        path="/"
        keywords="Kilis lojistik, uluslararası taşımacılık, parsiyel taşımacılık, komple araç lojistik, Global79 Lojistik"
        ogImage="/assets/images/hero-slide-1.png"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'Global79 Lojistik',
          url: 'https://global79lojistik.com/',
          image: 'https://global79lojistik.com/assets/images/logo.png',
          telephone: ['+905382323822', '+905324539979'],
          email: 'global79.lojistik@gmail.com',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Mehmet Abdi Bulut Mh. Fatma Şahin Cd. No:10',
            addressLocality: 'Kilis',
            addressRegion: 'Kilis',
            addressCountry: 'TR',
          },
          areaServed: ['Türkiye', 'Suriye', 'Azerbaycan', 'Irak', 'İran', 'Gürcistan', 'Ermenistan', 'Rusya'],
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Countries />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
